import { useState, useLayoutEffect } from "react";

export default function useDeviceDetect() {
  const [isMobile, setMobile] = useState(false);
  const [isDesktopMin, setIsDesktopMin] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useLayoutEffect(() => {
    // Start observing the element when the component is mounted
    const observer = new ResizeObserver((entries) => {
      window.requestAnimationFrame((): void | undefined => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        const { width } = entries[0].target.getBoundingClientRect();
        setIsDesktopMin(width < 1200);
        setIsTablet(width < 960);
        setMobile(width < 960);
        // setMobile(width <= 600);
      });
    });

    observer.observe(document.body);

    return () => {
      // Cleanup the observer by unobserving all elements
      observer.disconnect();
    };
  }, []);

  return { isMobile, isTablet, isDesktopMin };
}
